import axios from 'axios'

export default {
    state: {
        status: false,
        token: localStorage.getItem('token') || '',
        user: localStorage.getItem('user') || '',
        errors: [],
    },
    mutations: {
        auth_request(state) {
            state.status = 'loading';
        },
        auth_success(state, token, user) {
            state.status = 'success';
            state.token = token;
            state.user = user;
        },
        auth_error(state) {
            state.status = 'error';
        },
        logout(state) {
            state.status = '';
            state.token = '';
        },
    },
    actions: {
        login({ commit }, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request');
                axios({ url: 'login', data: user, method: 'POST'})
                    .then(resp => {
                        if(resp.data.status){
                            const token = resp.data.user.auth_token;
                            const user = resp.data.user
                            localStorage.setItem('token', token);
                            localStorage.setItem('user', user);
                            axios.defaults.headers.common['Authorization'] = token;
                            commit('auth_success', token, user);
                            resolve(resp);
                        }else{
                            reject(resp.data.errors);
                        }
                    })
                    .catch(err => {
                        commit('auth_error');
                        localStorage.removeItem('token');
                        reject(err);
                    });
            });
        },
        register(commit, user) {
            return new Promise((resolve, reject) => {
                axios({ url: 'register', data: user, method: 'POST'}).then(resp => {
                        if(resp.data.status){
                            resolve(resp);
                        }else{
                            reject(resp.data.errors);
                        }
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        },
        logout({ commit }) {
            return new Promise((resolve) => {
                commit('logout');
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                delete axios.defaults.headers.common['Authorization'];
                resolve();
            })
        }
    },
    getters: {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
        user: state => state.user
    }
}
